export const PORTAL_USERS_COLLECTION = 'portal_clientes_users';
export const LEGACY_USERS_COLLECTION = 'users';
